<!--回复选登-->
<template>
    <div class="reply-selection">
        <div class="module-name">
            <div class="module-title">回复选登</div>
        </div>
        <div class="question-box">
            <div class="question-item" v-for="(question,index) in tableData" :key="index">
                <div class="question-info">
                    <div v-text="'用户：'+question.name"></div>
                    <div v-text="'时间：'+question.createTimeStr"></div>
                </div>
                <div v-text="'标题：'+question.title"></div>
                <div v-text="'内容：'+question.content"></div>
                <div
                    v-if="!question.lookAnswer"
                    class="lookAnswer"
                    @click="lookAnswer(question,index)"
                >
                    查看回复
                    <i class="iconfont iconjiantou-up-down"></i>
                </div>
                <div
                    v-if="question.lookAnswer"
                    class="lookAnswer"
                    @click="lookAnswer(question,index)"
                >
                    收起回复
                    <i class="iconfont iconjiantou-up"></i>
                </div>
                <div v-if="question.lookAnswer" class="answers-box">
                    <div class="answers-item" v-for="(answer,index) in question.answers" :key="index">
                        <div class="name">
                            <div  v-text="answer.username+'：'"></div>
                            <div class="time" v-text="answer.repateTimeStr"></div>
                        </div>
                        <div class="answerscontent" v-text="answer.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "replySelection",
    data() {
        return {
            tableData: [],
            page: {
                current: 1,
                pagesize: 100
            }
        };
    },
    mounted() {
        this.requestData();
    },
    methods: {
        //初始化数据
        requestData() {
            this.$http
                .post("/question/queryPubQuestions", {
                    pageNo: this.page.current,
                    pageSize: this.page.pagesize
                })
                .then(res => {
                    if (res) {
                        this.tableData = res.result;
                        this.tableData.forEach(item => {
                            item.lookAnswer = false;
                        });
                    }
                });
        },
        //获取回复列表
        showQuestionPubAnswers(id) {
            return this.$http.post("/answer/showQuestionPubAnswers", {
                questionId: id,
                pageNo: 1,
                pageSize: 100
            });
        },
        //查看回复
        lookAnswer(question, index) {
            this.showQuestionPubAnswers(question.id).then(res => {
                question.lookAnswer = !question.lookAnswer;
                question.answers = res.result;
                this.$set(this.tableData, index, question);
            });
        }
    }
};
</script>
<style lang="less" scoped>
.reply-selection {
    .question-box {
        font-size: 16px;
    }
    .question-item {
        position: relative;
        margin-bottom: 10px;
        padding: 10px;
        padding-bottom: 50px;
        min-height: 100px;
        border: 1px #d6d6d6 dashed;
        border-radius: 4px;
        .question-info {
            display: flex;
            justify-content: space-between;
        }
        .lookAnswer {
            user-select: none;
            position: absolute;
            bottom: 5px;
            right: 5px;
            padding: 5px 10px;
            color: #337ab7;
            cursor: pointer;
        }
    }
    .answers-box {
        .answers-item{
            padding: 10px 0px;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px #f5f5f5 solid;
            .name{
                color: #337ab7;
                width: 20%;
            }
            .answerscontent{
                width: 80%;
                padding: 0px 10px;
            }
            .time{
                font-size: 12px;
            }
        }
    }
}
</style>